export default __webpack_public_path__ + "static/media/cash_in_safe.cd1b38ae.svg";